// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../../monolithImageSize.fragment.generated';
import { ThreeSixtyFragmentDoc } from '../three-sixty/ThreeSixty.fragment.generated';
import { CatalogueVideoFragmentDoc } from '../../../graphql/api/product/catalogueVideo.fragment.generated';
export const ProductGalleryFragmentDoc = `
    fragment productGallery on CatalogueProduct {
  productName
  suffix
  images {
    __typename
    id
    url
    small: size(name: SMALL) {
      ...monolithImageSize
    }
    small_x2: size(name: SMALL_X2) {
      ...monolithImageSize
    }
    medium: size(name: MEDIUM) {
      ...monolithImageSize
    }
    large: size(name: LARGE) {
      ...monolithImageSize
    }
    large_x2: size(name: LARGE_X2) {
      ...monolithImageSize
    }
  }
  ... on CatalogueJewellery {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
  }
  ... on CatalogueEngagementRing {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
    centreStoneConstraints {
      shape {
        translation(locale: $locale) {
          name
        }
      }
    }
  }
  ... on CatalogueWeddingRing {
    images360 {
      ...threeSixty
    }
    video {
      ...catalogueVideo
    }
  }
}
    `;